import { getColor, transparentize, mode } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => {
    const { colorScheme, theme } = props;
    const borderColor = mode(`gray.250`, transparentize('white', 0.24)(theme))(props);
    const disabledBorderColor = mode(transparentize('gray.600', 0.24)(theme), transparentize('white', 0.16))(props);
    const backGroundColor = mode('white', transparentize('white', 0.04)(theme))(props);
    const disabledBackGroundColor = mode(transparentize('gray.50', 0.5)(theme), transparentize('white', 0.08))(props);
    const hoverColor = transparentize(`${colorScheme}.300`, 0.12)(theme);
    const activeColor = transparentize(`${colorScheme}.300`, 0.24)(theme);
    return {
        control: {
            transition: 'box-shadow 250ms',
            border: '1px solid',
            borderRadius: 'full',
            borderColor: borderColor,
            bg: backGroundColor,
            color: 'white',
            boxSizing: 'content-box',
            cursor: 'pointer',
            _hover: {
                bg: hoverColor,
            },
            _active: {
                bg: activeColor,
            },
            _checked: {
                bg: backGroundColor,
                color: mode(`${colorScheme}.500`, `${colorScheme}.400`)(props),
                borderColor: borderColor,
                _hover: {
                    bg: hoverColor,
                    borderColor: borderColor,
                },
                _active: {
                    bg: activeColor,
                },
                _disabled: {
                    bg: disabledBackGroundColor,
                    borderColor: disabledBorderColor,
                    color: disabledBorderColor,
                },
                _before: {
                    content: `""`,
                    display: 'inline-block',
                    pos: 'relative',
                    w: '50%',
                    h: '50%',
                    borderRadius: '50%',
                    bg: 'currentColor',
                },
            },
            _disabled: {
                cursor: 'not-allowed',
                bg: disabledBackGroundColor,
                borderColor: disabledBorderColor,
            },
            _focus: {
                boxShadow: mode(`0 0 0 1px ${getColor(theme, 'blue.600')}, ` +
                    `0 0 0 5px ${transparentize('blue.400', 0.24)(theme)}`, `0 0 0 1px ${getColor(theme, 'blue.300')}, ` +
                    ` 0 0 0 5px ${transparentize(`blue.400`, 0.24)(theme)}`)(props),
            },
        },
        label: {
            cursor: 'pointer',
            color: mode('gray.600', 'white')(props),
            _disabled: {
                opacity: 1,
                cursor: 'not-allowed',
                color: mode(transparentize('gray.600', 0.36)(theme), transparentize('white', 0.36)(theme))(props),
            },
        },
    };
};
const parts = ['control', 'label', 'description', 'icon'];
const defaultProps = {
    size: 'md',
    colorScheme: 'blue',
};
const sizes = {
    md: {
        control: { width: 4, height: 4 },
        label: { fontSize: 'md' },
    },
    lg: {
        control: { width: 5, height: 5 },
        Label: { fontSize: 'lg' },
    },
};
export default {
    defaultProps,
    baseStyle: getBaseStyle,
    sizes,
    parts,
};
//# sourceMappingURL=radio.js.map